import React, {Component} from 'react'
import {$$} from '../../../helpers/localization'
import {CONVERTER} from '../../../utils/converter'
import PropTypes from "prop-types";

export default class RespiratoryRateForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.respiratory_rate ? $$('respiratory_rate_label') : null}<br/>
                <div className="form-group">
                    <div className="input-group mb-3">
                        <input type="number" step="0.01"
                               className={this.props.errors.respiratory_rate ? "custom-error form-control" : "form-control"}
                               value={this.props.respiratory_rate}
                               placeholder={$$('respiratory_rate_label')} name="respiratory_rate"
                               onChange={this.props.onInputChange} required/>
                        <div className="input-group-append">
                            <span className="input-group-text" style={{"height": "auto"}}
                                  id="basic-addon2">{CONVERTER.getFormatedRespiratoryRate()}</span>
                        </div>
                    </div>
                    <div
                        className={this.props.errors.respiratory_rate ? "custom-invalid-feedback" : "invalid-feedback"}>
                        {this.props.errors.respiratory_rate ? $$(this.props.errors.respiratory_rate) : $$('respiratory_rate_required_message')}
                    </div>
                </div>
            </div>
        )
    }
}

RespiratoryRateForm.propTypes = {
    clearSelectedEntry: PropTypes.func,
    createEntry: PropTypes.func,
    fetchSelectedUserHealthIssues: PropTypes.func,
    formDisabled: PropTypes.object,
    getHealthIssueList: PropTypes.func,
    onInputChange: PropTypes.func,
    healthIssues: PropTypes.object,
    logbookEntries: PropTypes.array,
    errors: PropTypes.any,
    respiratory_rate: PropTypes.any,
    medicalProfile: PropTypes.object,
    onHide: PropTypes.func,
    selectedUser: PropTypes.object,
    settings: PropTypes.object,
    show: PropTypes.bool,
    type: PropTypes.string,
    updateEntry: PropTypes.func,
    updateUserMedicalProfile: PropTypes.func
}